import { Grid, Skeleton } from '@mui/material'
import React from 'react'

function ContactLoader() {
  return (
    <>
    <Grid container className="pt-1" spacing={1}>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
    
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
        <Grid item md={3} xs={12}>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} animation="wave" />
        </Grid>
    </Grid>
    </>
  )
}

export default ContactLoader
